"use client"

import { initAnalytics, trackPage } from "common/analytics"
import dynamic from "next/dynamic"
import { usePathname, useSearchParams } from "next/navigation"
import { useEffect, useRef, useState } from "react"
import { hotjar } from "react-hotjar"

const AzureApplicationInsights = dynamic(
  () => import("common/AzureApplicationInsights"),
  { ssr: false }
)

const HOTJAR_ID = process.env.HOTJAR_ID

export default function AnalyticsWrapper() {
  const pathname = usePathname()
  const searchParams = useSearchParams()
  const [loadAzure, setLoadAzure] = useState(false)
  const isAnalyticsInitialized = useRef(false)

  useEffect(() => {
    if (!isAnalyticsInitialized.current) {
      initAnalytics()
      isAnalyticsInitialized.current = true

      if (HOTJAR_ID) {
        hotjar.initialize(parseInt(HOTJAR_ID), 6)
      }
    }

    const timer = setTimeout(() => {
      setLoadAzure(true)
    }, 1000)

    return () => clearTimeout(timer)
  }, [])

  useEffect(() => {
    if (!isAnalyticsInitialized.current) return

    const query = Object.fromEntries(searchParams.entries())
    const queryString = searchParams.toString()
    const hash = window.location.hash || ""

    trackPage({
      path: pathname,
      fullPath: queryString ? `${pathname}?${queryString}` : pathname,
      url: window.location.href,
      title: document.title,
      referrer: document.referrer,
      hash,
      queryParams: query,
      trackedAt: new Date().toISOString(),
    })

    window.appInsights?.trackPageView?.({
      uri: window.location.href,
      name: document.title,
      properties: {
        path: pathname,
        queryString,
        hash,
        ...query,
      },
    })
  }, [pathname, searchParams])

  return loadAzure ? <AzureApplicationInsights /> : null
}
